export enum PfType {
    TERM = 'TERM',
    CUSTOMER = 'CUSTOMER',
    PUBLIC = 'PUBLIC',
    TREATMENT = 'TREATMENT',
}
